import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "rgb(var(--color-insomnia-brand))",
      d: "M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0m0 .61a5.39 5.39 0 1 1 0 10.78A5.39 5.39 0 0 1 6 .61"
    }, null, -1),
    _createElementVNode("path", {
      fill: "rgb(var(--color-insomnia-brand))",
      "fill-rule": "evenodd",
      d: "M6.067 1.729a4.271 4.271 0 1 1-3.95 2.643A1.661 1.661 0 1 0 4.44 2.05a4.3 4.3 0 0 1 1.628-.321",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }